export default __webpack_public_path__ + "static/media/1718 cutlery top.da7ff4ff.png";